import React, {
  useCallback,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  ProductImage,
} from 'anf-core-react';

const placeholderImageUrl = 'https://img.abercrombie.com/is/image/anf/KIC_1XX-XXXX-XXXX-XXX?policy=product-small';

function WrappedImage({ classList, src }) {
  const [imageSource, setImageSource] = useState('');

  const onError = useCallback(() => {
    setImageSource(placeholderImageUrl);
  }, []);

  if (imageSource) {
    return (
      <ProductImage
        classList={classList}
        alt="Product Image"
        size="s"
        src={imageSource}
      />
    );
  }

  return (
    <ProductImage
      classList={classList}
      alt="Product Image"
      size="s"
      src={src}
      onError={onError}
    />
  );
}

WrappedImage.propTypes = {
  classList: PropTypes.string,
  src: PropTypes.string,
};

export default function ExchangeProductImage({
  imageId,
  gcFacePlateImageUrl,
}) {
  if (gcFacePlateImageUrl) {
    return (
      <WrappedImage
        classList="giftcard"
        src={gcFacePlateImageUrl}
      />
    );
  }
  if (imageId) {
    return (
      <WrappedImage
        src={`https://img.abercrombie.com/is/image/anf/${imageId}_prod1?policy=product-small`}
      />
    );
  }
  return (
    <WrappedImage
      src={placeholderImageUrl}
    />
  );
}

ExchangeProductImage.propTypes = {
  imageId: PropTypes.string,
  gcFacePlateImageUrl: PropTypes.string,
};
